import React from 'react'
import NavBar from './navbar/NavBar';
import Body from './body/Body';
import backgroundImage1 from '../../assets/images/home/background1.png';
import backgroundImage2 from '../../assets/images/home/background2.png';


const Home = () => {
    return (
        <div>
            <NavBar />
            <Body />
        </div>
    )
}

export default Home;